import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Form, Button, Card, Modal, Container, Toast } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { serviceActualizarDestinatario, serviceGetDetalles } from '../../../../api/api-confirmar-cierre';
import { useFormik } from 'formik';
import { validationSchemasDestinatario } from '../../../../common/validation-Schemas-cierre';
import { Auth, LoadingComponent } from 'recupero-comunes';
import Mensajes from '../../../mensajes';

const AddDestinatario = ({ cfg_form, showModal, setShowModal, idSolicitud, idMotivo, destinatario, destinatarioTO, setHandleSubmit }) => {
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [showModalTo, setShowModalTo] = useState(false);
    const [responseData, setResponseData] = useState({});
    const [tipoDestinatarios, setTipoDestinatarios] = useState([]);
    const [clasificaDestinos, setClasificaDestinos] = useState([]);

    useEffect(() => {
        if (showModal) initialValues();
    }, [showModal])

    const initialValues = () => {
        getTipoDestinatarios();
        getClasificaDestinos();

        if (destinatario) {
            setFieldValue('idTipoDestinatario', destinatario?.codTipoDestinatario ?? "");
            setFieldValue('idClasificaDestino', destinatario?.codClasDestino ?? "");
            setFieldValue('nombreDestinatario', destinatario?.nombreDestinatario ?? "");
            setFieldValue('emailDestinatario', destinatario?.emailDestinatario ?? "");
        }
    }

    const getTipoDestinatarios = async () => {
        let query = Buffer.from(JSON.stringify({ concepto: 269 })).toString('base64');
        const response = await serviceGetDetalles(query);

        setTipoDestinatarios(response);
    }

    const getClasificaDestinos = async () => {
        let query = Buffer.from(JSON.stringify({ concepto: 270 })).toString('base64');
        const response = await serviceGetDetalles(query);

        setClasificaDestinos(response);
    }

    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) { handleClose(); setHandleSubmit(true); }
    }

    const handleClose = () => {
        setShowModal(false); resetForm();
    }

    const validateClasificaDestino = () => {
        if (!destinatario) {
            if (!destinatarioTO) return true;
            else if (destinatarioTO && values.idClasificaDestino !== "270001") return true;
            else return false;
        } else {
            if (!destinatarioTO) return true;
            else if (destinatarioTO && destinatarioTO === destinatario.id) return true;
            else if (destinatarioTO && values.idClasificaDestino !== "270001") return true;
            else return false;
        }
    }

    const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        setFieldValue,
        resetForm,
        handleSubmit
    } = useFormik({
        initialValues: {
            idTipoDestinatario: "",
            idClasificaDestino: "",
            nombreDestinatario: "",
            emailDestinatario: "",
        },
        validationSchema: validationSchemasDestinatario(),
        onSubmit: async (data) => {
            if (validateClasificaDestino()) {
                setLoading(true);
                let dataResult = { ...data };

                dataResult.idCaso = llaves.idCaso;
                dataResult.idTipoNotificacion = idMotivo;
                dataResult.idSecuenciaNotifica = idSolicitud;
                dataResult.idUsuario = Auth.currentUser().rutUsuario;

                const response = await serviceActualizarDestinatario(dataResult);

                setLoading(false);
                setResponseData(response);
                setShowToast(true);
            }
            else
                setShowModalTo(true);
        }
    })

    return (
        <Fragment>
            <LoadingComponent show={loading} />

            <Modal show={showModal} onHide={setShowModal} size='lg'>
                <Card>
                    <Form onSubmit={handleSubmit}>
                        <Card.Header className='cardHeader'>
                            {cfg_form && cfg_form["modalconfirmarcierre-subtitleagregadest"]}
                        </Card.Header>

                        <Card.Body style={{ padding: '10px 25px 25px' }}>
                            <Row>
                                <Col md='6'>
                                    <Form.Label className="is_required mt-2">
                                        {cfg_form && cfg_form["modalconsultacierre-agregadest-tipo"]}
                                    </Form.Label>
                                    <Form.Select
                                        name='idTipoDestinatario'
                                        value={values.idTipoDestinatario}
                                        onChange={(e) => handleChange(e)}
                                        onBlur={handleBlur}>

                                        <option value={''}>Seleccione...</option>
                                        {tipoDestinatarios?.map((c) => (
                                            <option key={c.id} value={c.id}>{c.nombre}</option>
                                        ))}
                                    </Form.Select>
                                    {errors.idTipoDestinatario && touched.idTipoDestinatario &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.idTipoDestinatario}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='6'>
                                    <Form.Label className="is_required mt-2">
                                        {cfg_form && cfg_form["modalconsultacierre-agregadest-clasdestino"]}
                                    </Form.Label>
                                    <Form.Select
                                        name='idClasificaDestino'
                                        value={values.idClasificaDestino}
                                        onChange={(e) => handleChange(e)}
                                        onBlur={handleBlur}>

                                        <option value={''}>Seleccione...</option>
                                        {clasificaDestinos?.map((c) => (
                                            <option key={c.id} value={c.id}>{c.nombre}</option>
                                        ))}
                                    </Form.Select>
                                    {errors.idClasificaDestino && touched.idClasificaDestino &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.idClasificaDestino}
                                        </Form.Text>
                                    }
                                </Col>

                                <Col md='6'>
                                    <Form.Label className="is_required mt-2">
                                        {cfg_form && cfg_form["modalconsultacierre-agregadest-nombre"]}
                                    </Form.Label>
                                    <Form.Control
                                        name='nombreDestinatario'
                                        value={values.nombreDestinatario}
                                        onChange={(e) => handleChange(e)}
                                        onBlur={handleBlur}
                                    />
                                    {errors.nombreDestinatario && touched.nombreDestinatario &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.nombreDestinatario}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='6'>
                                    <Form.Label className="is_required mt-2">
                                        {cfg_form && cfg_form["modalconsultacierre-agregadest-email"]}
                                    </Form.Label>
                                    <Form.Control
                                        name='emailDestinatario'
                                        value={values.emailDestinatario}
                                        onChange={(e) => handleChange(e)}
                                        onBlur={handleBlur}
                                    />
                                    {errors.emailDestinatario && touched.emailDestinatario &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.emailDestinatario}
                                        </Form.Text>
                                    }
                                </Col>
                            </Row>
                        </Card.Body>
                        {showToast && 
                            <Mensajes
                                showToast={showToast}
                                handleCloseToast={handleCloseToast}
                                delay={5000}
                                responseData={responseData}
                            ></Mensajes>
                        }
                        <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                            <Button className='w-auto' variant='outline-info' onClick={handleClose}>
                                {cfg_form && cfg_form["modalconfirmarcierre-agregadest-btn-volver"]}
                            </Button>
                            <Button type="submit" className='w-auto buttonLetter' variant='danger'>
                                {cfg_form && cfg_form["modalconfirmarcierre-agregadest-btn-act"]}
                            </Button>
                        </Card.Footer>
                    </Form>
                </Card>
            </Modal>
            <Modal show={showModalTo} onHide={() => setShowModalTo(false)} size='md'>
                <Card>
                    <Card.Header style={{ backgroundColor: '#4F517A', color: 'white' }}>Información</Card.Header>
                    <Card.Body>Solo puede existir un destinatario con <strong>Clasifica Destino</strong> de tipo <strong>TO</strong>.</Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalTo(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                .is_required:after {
                    content: "*";
                    margin-left: 2px;
                    color: #000;
                    font-weight: 500;
                    font-size: 12pt;
                }
                form label {
                    font-weight: bold;
                    font-size: 14px;
                    margin-bottom: 0;
                    margin-top: 5px;
                    margin-top: 2px
                }
            `}
            </style>
        </Fragment>
    )
}

export default AddDestinatario;